
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/conversation-sources/facebook/facebookPage.tmpl");
    var Button = require("ui/button/Button");

    var FacebookPageView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        FacebookPageView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "facebook-page",
            template: template,
            ui:{
                name: ".name",
                icon: ".icon",
                subscribedMessageContainer: ".subscribed-message-container",
                subscribedMessage: ".subscribed-message",
                unsubscribeContainer: ".unsubscribe-container",
                unsubscribe: ".unsubscribe",
                subscribeContainer: ".subscribe-container",
                subscribe: ".subscribe"
            },
            uiComponents: {
                unsubscribe:{
                    type: Button,
                    options: {
                        el: "view.ui.unsubscribe",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_unsubscribeClick"
                    }
                },
                subscribe:{
                    type: Button,
                    options: {
                        el: "view.ui.subscribe",
                        permutation: Button.PERMUTATION.BTN_HEIGHT_ALIGN
                    },
                    events: {
                        "click": "_subscribeClick"
                    }
                }
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            setError: function() {
                this.ui.icon.addClass("error");
                this.ui.subscribedMessage.addClass("error");
                this.ui.subscribedMessage.text(LE.translator.translate("LEFramework.global.please.try.again"));
                this.ui.subscribedMessageContainer.removeClass("hide");
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>

            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                this.connectorModels = options.connectorModels;
                this.channel = LEManager.media.channel("conversationSources");
            },

            _onRender: function(options) {
                this.ui.name.text(this.model.get("name"));
                this._initFacebookPage();
            },

            _initFacebookPage: function() {
                var isSubscribed = _.some(this.connectorModels, function(connectorModel) {
                    if(connectorModel.get("configuration") && this.model.id === connectorModel.get("configuration").pageId) {
                        return true;
                    }
                }, this);
                this._showSuccessSubscribedState(isSubscribed);
            },

            _showSuccessSubscribedState: function(isSubscribed) {
                if(isSubscribed) {
                    this.ui.subscribedMessageContainer.toggleClass("hide");
                    this.ui.unsubscribeContainer.toggleClass("hide");
                } else {
                    this.ui.subscribeContainer.toggleClass("hide");
                }
            },

            _subscribeClick: function() {
                this.channel.trigger("facebook:subscribe:page", {pageId: this.model.id, pageName: this.model.get("name"), accessToken: this.model.get("access_token")});
            },

            _unsubscribeClick: function() {
                this.channel.trigger("facebook:unsubscribe:page", {pageId: this.model.id});
            }
            //</editor-fold>
        });
    }

    LE.module("LEManager", moduleDefinition);

    return FacebookPageView;

});
